import SharedEmptyState from "../EmptyState";
import emptyStateImage from "../../assets/images/fixtures-empty-state.svg";

/**
 * EmptyState - Displayed when no fixtures exist
 */
const EmptyState = ({ onGenerateFixtures, onCreateFixture, hideButtons }) => {
  return (
    <SharedEmptyState
      illustration={emptyStateImage}
      heading="Let's create our first fixtures"
      description="Get started quickly with auto-generated fixtures, or create your own manually."
      actions={
        !hideButtons ? (
          <>
            <button
              onClick={onCreateFixture}
              className="flex-1 h-11 bg-app-card text-[#FEFCEB] rounded-full font-medium text-[15px] hover:opacity-50 transition-opacity"
            >
              Create fixture
            </button>
            <button
              onClick={onGenerateFixtures}
              className="flex-1 h-11 bg-[#00E7FF] text-[#021529] rounded-full font-medium text-[15px] hover:opacity-50 transition-opacity"
            >
              Generate fixtures
            </button>
          </>
        ) : null
      }
    />
  );
};

export default EmptyState;
